import { WidgetComponentType } from "models/screenshot";

import { useMapScreenshotSettingsControls } from "components/map/hooks";
import useMPCScreenshotSettingsControls from "components/multiphase-chart/hooks/useMPCScreenshotSettingsControls";
import { useSamChartScreenshotSettingsControls } from "components/sam/hooks";
import {
  ControlDef,
  SettingsControl,
  SettingsGroups
} from "components/screenshot/models/controlDefinition";
import { buildControls } from "components/screenshot/utils/buildScreenshotControls";
import { useChartScreenshotSettingsControls } from "components/shared/charts/hooks";
import { useXDAScreenshotSettingsControls } from "components/vis/hooks";

import { useScreenshotContext } from ".";

const DIMENSION_CONTROLS: readonly ControlDef[] = [
  {
    name: "height",
    label: "Height",
    group: SettingsGroups.preset,
    input: { type: "number", min: 0, unit: "px", step: 10 },
    visibility: "standalone"
  },
  {
    name: "width",
    label: "Width",
    group: SettingsGroups.preset,
    input: { type: "number", min: 0, unit: "px", step: 10 },
    visibility: "standalone"
  }
];

export function useScreenshotSettingsControls(): SettingsControl[] {
  // hooks
  const { widget, settings } = useScreenshotContext();
  const chartControls = useChartScreenshotSettingsControls();
  const mapControls = useMapScreenshotSettingsControls();
  const mpcControls = useMPCScreenshotSettingsControls();
  const samChartControls = useSamChartScreenshotSettingsControls();
  const XDAControls = useXDAScreenshotSettingsControls();

  if (!widget || !settings) return [];

  const isDashboard = widget?.widgetComponentType === WidgetComponentType.Dashboard;
  const ctx = { isDashboard };

  return [
    ...buildControls(DIMENSION_CONTROLS, ctx),
    ...chartControls,
    ...mapControls,
    ...mpcControls,
    ...samChartControls,
    ...XDAControls
  ];
}
